import { AuthRedirectSpinner } from './auth-redirect-spinner';
import { BlockRenderer } from './block-renderer';
import { withAuthenticationGuard } from './with-authentication-guard';

export const AuthGuardedBlockRenderer = withAuthenticationGuard(BlockRenderer, {
    OnRedirecting: AuthRedirectSpinner,
});
